export const locale = {
	lang: 'en',
	data: {
		HEADER: {
			'LOGIN': 'Log in',
			'APPLICATION': 'Apps',
			'PROFILE': 'Profile',
			'SETTINGS': 'Settings',
			'LOGOUT': 'Logout',
			'SEARCH': 'Search',
		},
		FOOTER: {
			'ALL_RIGHTS_RESERVED': 'All rights reserved',
		},
		NOTIFICATION: {
			SUCCESS: 'Success',
			INFO: 'Information',
			WARNING: 'Warning',
			ERROR: 'Error'
		},
		CONFIRM_DIALOG: {
			CONFIRMATION: 'Confirmation',
			CONFIRM: 'Confirm',
			CANCEL: 'Cancel'
		},
		CUSTOMER_TREE_TYPE: {
			UNDEF: 'Undefined',
			RESORT: 'Resort',
			SECTOR: 'Sector',
			ZONE: 'Weather zone'
		},
		CONFIRM_UNSAVED_CHANGES: 'You have not saved your changes, do you want to continue ?' ,
		ERROR: 'An error occured!',
		POST_PUT_USER_CONFLICT: 'There is already a user with this email address',
		GET_APPS_ERROR: 'An error occured while getting applications!',
		GET_CUSTOMER_TREE_ERROR: 'An error occurer while getting customer tree!',
		GET_USERS_ERROR: 'An error occured while getting users!',
		GET_USER_ACCESS_ERROR: 'An error occured while getting user access!',
		GET_USER_APPLICATIONS_ERROR: 'An error occured while getting user applications!'
	}
};
